<template>
     <div class='bgWhite'>
        <!-- <div class="logoBox"><img src="@/assets/imgs/logo.png" alt=""></div>
        <div class="loginBtn blue" @click='toAuthFn'>授权登录</div> -->
    </div>
</template>
<script>
import {isWexinmobile,domain} from '@/utils/utils.js'
import { mapActions } from 'vuex'
export default {
  created(){
    if(isWexinmobile()){
        const token = localStorage.getItem('token')
        const userInfos = JSON.parse(localStorage.getItem('userInfo'))
        if (!token) {
          window.location.replace(domain+'Wechat/wxLogin')
        }else{
          const loginStus = localStorage.getItem('loginStus') 
          if(loginStus=='true'){
              this.setNavRoute()
          }else{
            if(userInfos.mobile){
                this.$router.replace({name:'login'})
            }else{
                this.$router.replace({name:'bindTel'});
            }
          }
          
        }
    }else{
      this.$router.replace({name:'login'})
    }


    
  },
  methods:{
    ...mapActions([
      'setNavRoute'
    ]),
    toAuthFn(){
      window.location.replace(domain+'Wechat/wxLogin')
    }
  }
};
</script>
<style scoped>
.logoBox{
    width:100%;
    padding:19px 0 55.5px 0;
    text-align:center;
    background-color:#fff;
}
.logoBox img{
    width:65.5px;
}
.loginBtn{
    width:300px;
    height:45px;
    background:#dedede;
    border-radius:22.5px;
    color:#ffffff;
    letter-spacing:3px;
    font-size:16px;
    line-height:45px;
    margin:0 auto;
    text-align:center;
    margin-top:64px;
}
.loginBtn.blue{
    background:#00878b;
}
</style>


// WEBPACK FOOTER //
// src/components/transfer.vue